/* F-13 export list. */
.page {
  max-width: 760px;
  padding-bottom: var(--dimension-space-8);
}
.pad {
  padding: var(--dimension-space-4) var(--dimension-space-5);
}
.flat {
  margin: 0;
}
.muted {
  color: var(--color-text-secondary);
}
.top {
  padding: var(--dimension-space-4) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.notice {
  margin: 0;
  padding: var(--dimension-space-2) var(--dimension-space-5);
  background: var(--color-surface-sunken);
}
.head {
  margin: var(--dimension-space-4) 0 0;
  padding: var(--dimension-space-2) var(--dimension-space-5);
  border-bottom: var(--dimension-line-control) solid var(--color-text-primary);
}
.list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--dimension-space-4);
  padding: var(--dimension-space-3) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.link {
  display: inline-flex;
  align-items: center;
  gap: var(--dimension-space-1);
  padding: 0 var(--dimension-space-3);
  color: var(--color-text-primary);
}
